var map = {
	"./avatar_1.jpg": "d1f3",
	"./avatar_2.jpg": "fb34",
	"./avatar_3.jpg": "7529",
	"./avatar_4.jpg": "e54d",
	"./avatar_5.jpg": "f8d0",
	"./avatar_6.jpg": "8474",
	"./avatar_7.jpg": "fa7f",
	"./avatar_8.jpg": "094d",
	"./avatar_9.jpg": "3d3b",
	"./avatar_real_1.jpg": "3fd3",
	"./avatar_real_2.jpg": "36e4",
	"./avatar_real_3.jpg": "118c",
	"./avatar_real_4.jpg": "8803",
	"./avatar_real_5.jpg": "7450",
	"./avatar_real_6.jpg": "ee6c",
	"./avatar_real_7.jpg": "bebb",
	"./avatar_real_8.jpg": "55ca",
	"./avatar_real_9.jpg": "1013"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84f8";